/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

// Images
import mobileMockupLight from '../../../images/mobile_mockup_light.svg';
import mobileMockupDark from '../../../images/mobile_mockup_dark.svg';
import heroDark from '../../../images/hero_dark.svg';
import heroLight from '../../../images/hero_light.svg';

// Styles
import commonStyles from './styles/common/styles';
import {withStyles} from '@material-ui/core/styles';
import combineStyles from '../../../utilities/combine_styles';
import heroStylesDark from './styles/dark/styles';
import heroStylesLight from './styles/light/styles';

/**
 * Hero
 */
class Hero extends React.Component {
  sendEmail = () => {
    window.location.href =
      'mailto:brandonfitzh2o@gmail.com?subject=Bitz LLC Inquiry';
  };

  /**
   * Lifecyle method
   * @return {component}container
   */
  render() {
    const {classes, mode} = this.props;

    return (
      <div
        className={
          mode.theme.enableDarkMode
            ? classes.heroBackgroundDark
            : classes.heroBackgroundLight
        }
      >
        <Hidden xsDown implementation="css">
          <Grid container spacing={24}>
            <Grid item xs={12} sm={6}>
              <div
                className={
                  mode.theme.enableDarkMode
                    ? classes.heroHeadlineDark
                    : classes.heroHeadlineLight
                }
              >
                One Developer.
                <br />
                Infinite Possibilities.
              </div>
              <div
                className={
                  mode.theme.enableDarkMode
                    ? classes.heroMissionDark
                    : classes.heroMissionLight
                }
              >
                Richmond Virginia's leading web and mobile application
                development company that crafts inspiring solutions to
                technical inquiries.
                <Button
                  className={
                    mode.theme.enableDarkMode
                      ? classes.contactDark
                      : classes.contactLight
                  }
                  onClick={this.sendEmail}
                  variant="contained"
                >
                  <a href="#contact" className={classes.link}>
                    Contact
                  </a>
                </Button>
              </div>
              <img
                className={classes.heroVector}
                alt={
                  mode.theme.enableDarkMode
                    ? 'nighttime activities'
                    : 'people enjoying the outdoors'
                }
                src={mode.theme.enableDarkMode ? heroDark : heroLight}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <img
                className={classes.heroImage}
                alt={
                  mode.theme.enableDarkMode
                    ? 'bitz mobile app development dark theme'
                    : 'bitz mobile app development light theme'
                }
                src={
                  mode.theme.enableDarkMode
                    ? mobileMockupDark
                    : mobileMockupLight
                }
              />
            </Grid>
          </Grid>
        </Hidden>
        <Grid container spacing={24}>
          <Hidden smUp implementation="css">
            <Grid item xs={12} sm={6}>
              <div
                className={
                  mode.theme.enableDarkMode
                    ? classes.heroHeadlineMobileDark
                    : classes.heroHeadlineMobileLight
                }
              >
                One Developer.
                <br />
                Infinite Possibilities.
              </div>
              <div
                className={
                  mode.theme.enableDarkMode
                    ? classes.heroMissionMobileDark
                    : classes.heroMissionMobileLight
                }
              >
                Richmond Virginia's leading web and mobile application
                development company that crafts inspiring solutions to
                technical inquiries.
                <Button
                  className={
                    mode.theme.enableDarkMode
                      ? classes.contactDark
                      : classes.contactLight
                  }
                  onClick={this.sendEmail}
                  variant="contained"
                >
                  <a href="#contact" className={classes.link}>
                    Contact
                  </a>
                </Button>
              </div>
              <img
                className={classes.heroVectorMobile}
                alt={
                  mode.theme.enableDarkMode
                    ? 'nighttime activities'
                    : 'people enjoying the outdoors'
                }
                src={mode.theme.enableDarkMode ? heroDark : heroLight}
              />
            </Grid>
          </Hidden>
        </Grid>
      </div>
    );
  }
}

Hero.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const combinedStyles = combineStyles(
    commonStyles,
    heroStylesDark,
    heroStylesLight
);

export default withStyles(combinedStyles, {withTheme: true})(Hero);
